module.exports = __webpack_public_path__ + "img/bg1.6d7fd77f.png";